/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.ChangePasswordResource = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The ChangePasswordResource model module.
   * @module model/ChangePasswordResource
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>ChangePasswordResource</code>.
   * The resource used to change password.
   * @alias module:model/ChangePasswordResource
   * @class
   * @param currentPassword {String} Required. The current password of the account.
   * @param newPassword {String} Required. The new password of the account. It must be at least 6 characters.
   * @param confirmPassword {String} Required. The confirmation password. It must be identical to the \"CurrentPassword\" field.
   */
  var exports = function(currentPassword, newPassword, confirmPassword) {
    var _this = this;

    _this['currentPassword'] = currentPassword;
    _this['newPassword'] = newPassword;
    _this['confirmPassword'] = confirmPassword;
  };

  /**
   * Constructs a <code>ChangePasswordResource</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ChangePasswordResource} obj Optional instance to populate.
   * @return {module:model/ChangePasswordResource} The populated <code>ChangePasswordResource</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('currentPassword')) {
        obj['currentPassword'] = ApiClient.convertToType(data['currentPassword'], 'String');
      }
      if (data.hasOwnProperty('newPassword')) {
        obj['newPassword'] = ApiClient.convertToType(data['newPassword'], 'String');
      }
      if (data.hasOwnProperty('confirmPassword')) {
        obj['confirmPassword'] = ApiClient.convertToType(data['confirmPassword'], 'String');
      }
    }
    return obj;
  }

  /**
   * Required. The current password of the account.
   * @member {String} currentPassword
   */
  exports.prototype['currentPassword'] = undefined;
  /**
   * Required. The new password of the account. It must be at least 6 characters.
   * @member {String} newPassword
   */
  exports.prototype['newPassword'] = undefined;
  /**
   * Required. The confirmation password. It must be identical to the \"CurrentPassword\" field.
   * @member {String} confirmPassword
   */
  exports.prototype['confirmPassword'] = undefined;



  return exports;
}));



